import { render, staticRenderFns } from "./OrgManagementList.vue?vue&type=template&id=720b06d9&"
import script from "./OrgManagementList.vue?vue&type=script&lang=js&"
export * from "./OrgManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports